<template>
  <div>
    <div class="card">

    <div class="card-header bg-transparent header-elements-sm-inline py-sm-0">

      <h5 class="card-title py-sm-3"><span class="icon-list"></span>&nbsp;&nbsp;Quality List</h5>

      <div class="header-elements">
        <form action="#">
          <div class="form-group-feedback form-group-feedback-right">
            <input  id="txtsearch" type="search" class="form-control wmin-sm-200" placeholder="Search..." autocomplete="off">
            <div class="form-control-feedback">
              <i class="icon-search4 font-size-base text-muted"></i>
            </div>
          </div>
        </form>

      </div>
    </div>


    <div class="table-responsive">
      <table id="quality_table"
             class="table  table-hover  table-bordered table-condensed table-columned"
             data-search="false"
             data-pagination="true"
             data-show-refresh="false"
             data-show-columns="false"
             data-page-list="[10, 25, 50, 100, ALL]"
             data-show-footer="false"
             data-toggle="context"
             data-target=".context-table">
        <thead>
        <tr>
          <th data-field="id" data-class="d-none">id</th>
          <th data-formatter="runningFormatter" data-width="75" >S.No</th>
          <th data-field="status" data-width="150">Status</th>
          <th data-field="name">Name</th>
          <th data-field="type">Type</th>
          <th data-field="hsn">HSN</th>
          <th data-field="rate_based_on" data-formatter="formatRateBasedOn">Calc</th>
          <th data-field="rate_based_on" data-formatter="formatRateBasedOn">Calc</th>
        </tr>
        </thead>
        <tbody>
        </tbody>
        <tfoot>
        </tfoot>
      </table>
    </div>

    <!-- Context Menu -->
    <div id="context-menu" class="context-table">
      <div class="dropdown-menu">

        <a href="#" class="dropdown-item" @click="loadData"><i class="icon-reset" style="color: darkgreen"></i>Refresh</a>
        <div class="dropdown-divider"></div>
        <a href="#" class="dropdown-item"> <i class="icon-pencil3" ></i>Modify</a>
        <div class="dropdown-divider"></div>
        <a href="#" class="dropdown-item"><i class="icon-blocked text-danger"></i>Remove</a>
      </div>
    </div>
    <!-- End of Context Menu -->

    <!-- Clickable menu -->
    <ul class="fab-menu fab-menu-fixed fab-menu-bottom-right is_stuck" data-fab-toggle="hover" z-index="99">
      <li>
        <a class="fab-menu-btn btn bg-primary-600 btn-float rounded-round btn-icon" @click="showModal">
          <i class="fab-icon-open icon-plus3"></i>
          <i class="fab-icon-close icon-plus3"></i>
        </a>
      </li>
    </ul>
    <!-- /clickable menu -->

    <vmodal name="quality_window" transition="nice-modal-fade" :delay="100" :resizable="true" :width="750" :height ="430" @closed="afterClose"  >
      <FmsQualityForm v-bind:myquality="quality" v-on:quality_saved="loadData" v-on:quality_window_closed="closeModal" ></FmsQualityForm>
    </vmodal>


    <div class="modal" id="quality_window"  >
      <div class="modal-dialog  modal-full modal-dialog-centered modal-dialog-scrollable" >
        <div class="modal-content" >

          <!-- Modal body -->
          <div class="modal-body"  style="padding: 0px;" >
            <FmsQualityForm v-bind:myquality="quality" v-on:quality_saved="loadData" v-on:quality_window_closed="closeModal" ></FmsQualityForm>
          </div>


        </div>
      </div>
    </div>

  </div>
  </div>
</template>

<script>
  import FmsQualityForm from '@/views/fms/quality/FmsQualityForm.vue'
  import FabButton from '@/components/core/FabButton.vue'
  import moment from 'moment-timezone'
  import {userService} from '@/store/auth-header.js'
  export default {
    name: 'QualityView',
    components: {
      FmsQualityForm,
      FabButton
    },
    data () {
      return {
        mytable: {},
        quality:  JSON.parse('{"id":0,"type":"Knitted","name":"","expo_desc":"","hsn":"","status":"Active","rate_based_on":0,"weight":0,"colorcharts":[]}')
      }
    },
    created () {

    },
    mounted () {
      let self = this;

      self.$data.quality = JSON.parse('{"id":0,"type":"Knitted","name":"","expo_desc":"","hsn":"","status":"Active","rate_based_on":0,"weight":0,"colorcharts":[]}');

      this.$data.mytable = $('#quality_table');

      this.$data.mytable.bootstrapTable();
      $('[data-toggle="popover"]').popover();

      this.$data.mytable.contextmenu({
        target: '#context-menu',
        scopes: 'tbody > tr',
        onItem: function (row, e) {
          var id = $(row.children('*')[0]).text();

          if ($(e.target).text() === 'Refresh') {
            self.loadData();
          }else if ($(e.target).text() === 'Modify') {
            self.modifyDocument (id);
          } else if ($(e.target).text() === 'Remove') {
            self.removeDocument(id);
          }
        }
      });

      $('#txtsearch').keyup(function () {
        var val = $.trim($(this).val()).replace(/ +/g, ' ').toLowerCase()
        $('#quality_table>tbody>tr').show().filter(function () {
          var text = $(this).text().replace(/\s+/g, ' ').toLowerCase()
          return !~text.indexOf(val)
        }).hide()
      });

      self.loadData();
    },
    methods: {
      closeModal () {
        this.$data.quality = JSON.parse('{"id":0,"type":"Knitted","name":"","expo_desc":"","hsn":"","status":"Active","rate_based_on":0,"weight":0,"colorcharts":[]}');
        this.$modal.hide('quality_window');
        $('#quality_window').modal('hide');
      },
      showModal () {
        // $('#quality_window').modal('show');
        this.$modal.show('quality_window');
      },
      beforeOpen(){
        console.log('beforeOpen');
      },
      afterClose(){
        this.$data.quality = JSON.parse('{"id":0,"type":"Knitted","name":"","expo_desc":"","hsn":"","status":"Active","rate_based_on":0,"weight":0,"colorcharts":[]}');
      },
      loadData () {
        const self = this;

        const requestOptions = {
          method: 'GET',
          mode:"cors",
          headers: userService.authHeader()
        };

        self.$modal.hide('quality_window');

        $(self.$data.mytable).block({
          msg: '<i class="icon-spinner2 spinner"></i>',
          overlayCSS: {
            backgroundColor: '#fff',
            opacity: 0.8,
            cursor: 'wait',
            'box-shadow': '0 0 0 1px #ddd'
          },
          css: {
            border: 0,
            padding: 0,
            backgroundColor: 'none'
          }
        });

        self.$data.mytable.bootstrapTable('load',[]);

        fetch(`${process.env.VUE_APP_ROOT_API}api/qualities/after/1`,requestOptions).then(userService.handleResponse).then(function (resp) {
          if(resp.ok) {
            if( _.isArray(resp.data)){
              self.$data.mytable.bootstrapTable('load', resp.data);
            }
          } else {
            swal ( { title: "Oops!" ,  text: resp.msg, type:  "error"} );
          }
        }).catch(function (err) {
          swal ( { title: "Oh noes!" ,  text: err.toString(), type:  "error"} );
        }).finally(function () {
          $(self.$data.mytable).unblock();
        });
      },
      modifyDocument (id) {
        const self = this;

        const requestOptions = {
          method: 'GET',
          mode:"cors",
          headers: userService.authHeader()
        };

        self.$data.quality = JSON.parse('{"id":0,"type":"Knitted","name":"","expo_desc":"","hsn":"","status":"Active","rate_based_on":0,"weight":0,"colorcharts":[]}');

        fetch(`${process.env.VUE_APP_ROOT_API}api/quality/${id}`,requestOptions).then(userService.handleResponse).then(function (resp) {
          if(resp.ok) {
            self.$data.quality = resp.data;
            self.$modal.show('quality_window');
          } else {
            swal ( { title: "Oops!" ,  text: resp.msg, type:  "error"} );
          }
        }).catch(function (err) {
          swal ( { title: "Oh noes!" ,  text:  err.toString() , type:  "error"} );
        });

      },
      removeDocument (id) {
        const self = this;

        self.$data.quality.id = id;

        const requestOptions = {
          method: 'DELETE',
          mode:'cors',
          headers: userService.authHeader(),
          body: JSON.stringify(self.$data.quality)
        };

        swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          timer: 3000,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete this!'
        }).then((result) => {
          if (result.value) {
            fetch(`${process.env.VUE_APP_ROOT_API}api/quality`,requestOptions).then(userService.handleResponse).then(function (resp) {
              self.$modal.hide('quality_window')
              self.loadData();
              swal(
                'Deleted!',
                'Your request has been processed',
                'success'
              );
            }).catch(function (err) {
              swal({ title: "Oops", text: err.toString(), type: "error" });
            });
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
